import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// text,email,tel,textarea,password
@Component({
    selector: 'medpt-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.scss'],
    standalone: false
})
export class TextboxComponent implements OnInit {

  constructor(private modelDialogService: NgbModal) { }

  ngOnInit(): void {
  }

  @Input() field: any = {};
  @Input() form!: FormGroup;
  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  get isReadOnly() {
    return this.field.MergeFieldName == 'IPFduration'
      || this.field.MergeFieldName == 'CorrectedDLCO'
      || this.field.MergeFieldName == 'Formula'
      || this.field.MergeFieldName == 'FormCounter';
  }
}
